import { render, staticRenderFns } from "./EditInvoiceView.vue?vue&type=template&id=2c2748dc&"
import script from "./EditInvoiceView.vue?vue&type=script&lang=js&"
export * from "./EditInvoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports